import EmptyState from './empty-state';

export default EmptyState;
